import React, { useEffect } from "react";
import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";
import { useHistoricoContext } from "../../../../Context/Historico";
import { useUserInfor } from "../../../../Context/User";

import SpinnerComponent from "../../../Loding/Spinner";
import ComponenteHistorico from "../ComponenteHistorico";

interface IComponenteHistoricoCasoProps {
    ID_CASO?: number;
    showTipoContato?: boolean;
    height?: number;
}

export default function ComponenteHistoricoCaso(
    props: IComponenteHistoricoCasoProps
) {
    const { LoadHistoricoCaso, historicoCaso, loadingHistorico } =
        useHistoricoContext();
    const { Atendimento, bloquearInteracoes } = useAtendimentoPage();
    const { UserInfor } = useUserInfor();

    const shouldLoad = loadingHistorico.caso === "preLoad";
    const modificavel =
        Atendimento?.ID_USUARIO_RESPONSAVEL === UserInfor.ID_USUARIO &&
        !bloquearInteracoes &&
        UserInfor.FUNCOES.some(
            (f) => f.NM_FUNCAO === "ADM_EXCLUIR_HISTORICO_CASO"
        );

    useEffect(() => {
        if (shouldLoad) {
            LoadHistoricoCaso();
        }
    }, [shouldLoad, LoadHistoricoCaso]);

    return loadingHistorico.caso === "loaded" ? (
        <ComponenteHistorico
            historico={historicoCaso}
            ID_CASO={props.ID_CASO}
            modificavel={modificavel}
            height={props.height}
        />
    ) : (
        <SpinnerComponent />
    );
}
